import * as moment from 'moment';
import {Moment} from 'moment';

export function displayDateWithTime(date: Date | string | null | Moment): string | null {
  if (date) return moment(date).local().format("YYYY-MM-DD (hh:mm)");
  return null;
}

export function displayShortDate(date: Date | string | number | null | Moment): string | null {
  if (date) return moment(date).local().format("YYYY-MM-DD");
  return null;
}

export function displayYYYMMDDJavaLocalDate(date: Date | string | null | Moment): string | null {
  if (date) {
    return moment(date, "YYYY,MM,DD").local().format("YYYYMMDD");
  }

  return null;
}

export function displayDateDurationDays(date: string | Date) {
  const days = moment(date).diff(moment(), 'days');
  return days > 0 ? moment(date).diff(moment(), 'days') + ' days' : '0 days';
}
